/** Generated by @gh/common callable client codegen. Do not edit manually. */

import type { CallableApiConfig, RouteTypeMap } from "@gh/common/callable-client";
import type { BridgeAdminCreateBridgePolicyRequest, BridgeAdminCreateBridgePolicyResponse, BridgeAdminEnsureBridgePatientRequest, BridgeAdminEnsureBridgePatientResponse, BridgeAdminListBookableProviderEligibilityRequest, BridgeAdminListBookableProviderEligibilityResponse, BridgeAdminResolveBridgePolicyStatusRequest, BridgeAdminResolveBridgePolicyStatusResponse, BridgeAdminRevalidateBridgePolicyRequest, BridgeAdminRevalidateBridgePolicyResponse, BridgeCreateBridgePolicyRequest, BridgeCreateBridgeServiceEligibilityRequest, BridgeCreateBridgeServiceEligibilityResponse, BridgeEnsureBridgePatientRequest, BridgeListBookableProviderEligibilityRequest, BridgePreviewBridgeMappedNoteRequest, BridgePreviewBridgeMappedNoteResponse, BridgeResolveBridgePolicyStatusRequest, BridgeResolveBridgeServiceEligibilityStatusRequest, BridgeResolveBridgeServiceEligibilityStatusResponse, BridgeRevalidateBridgePolicyRequest, BridgeTriggerDiscoverProvidersRequest, BridgeTriggerDiscoverProvidersResponse, BridgeTriggerProviderResolveRequest, BridgeTriggerProviderResolveResponse } from "../../src/types";



export interface BridgeRouteTypeMap extends RouteTypeMap {
  adminCreateBridgePolicy: {
    request: BridgeAdminCreateBridgePolicyRequest;
    response: BridgeAdminCreateBridgePolicyResponse;
  };
  adminEnsureBridgePatient: {
    request: BridgeAdminEnsureBridgePatientRequest;
    response: BridgeAdminEnsureBridgePatientResponse;
  };
  adminListBookableProviderEligibility: {
    request: BridgeAdminListBookableProviderEligibilityRequest;
    response: BridgeAdminListBookableProviderEligibilityResponse;
  };
  adminResolveBridgePolicyStatus: {
    request: BridgeAdminResolveBridgePolicyStatusRequest;
    response: BridgeAdminResolveBridgePolicyStatusResponse;
  };
  adminRevalidateBridgePolicy: {
    request: BridgeAdminRevalidateBridgePolicyRequest;
    response: BridgeAdminRevalidateBridgePolicyResponse;
  };
  createBridgePolicy: {
    request: BridgeCreateBridgePolicyRequest;
    response: BridgeAdminCreateBridgePolicyResponse;
  };
  createBridgeServiceEligibility: {
    request: BridgeCreateBridgeServiceEligibilityRequest;
    response: BridgeCreateBridgeServiceEligibilityResponse;
  };
  ensureBridgePatient: {
    request: BridgeEnsureBridgePatientRequest;
    response: BridgeAdminEnsureBridgePatientResponse;
  };
  listBookableProviderEligibility: {
    request: BridgeListBookableProviderEligibilityRequest;
    response: BridgeAdminListBookableProviderEligibilityResponse;
  };
  previewBridgeMappedNote: {
    request: BridgePreviewBridgeMappedNoteRequest;
    response: BridgePreviewBridgeMappedNoteResponse;
  };
  resolveBridgePolicyStatus: {
    request: BridgeResolveBridgePolicyStatusRequest;
    response: BridgeAdminResolveBridgePolicyStatusResponse;
  };
  resolveBridgeServiceEligibilityStatus: {
    request: BridgeResolveBridgeServiceEligibilityStatusRequest;
    response: BridgeResolveBridgeServiceEligibilityStatusResponse;
  };
  revalidateBridgePolicy: {
    request: BridgeRevalidateBridgePolicyRequest;
    response: BridgeAdminRevalidateBridgePolicyResponse;
  };
  triggerDiscoverProviders: {
    request: BridgeTriggerDiscoverProvidersRequest;
    response: BridgeTriggerDiscoverProvidersResponse;
  };
  triggerProviderResolve: {
    request: BridgeTriggerProviderResolveRequest;
    response: BridgeTriggerProviderResolveResponse;
  };
}

export const bridgeApiConfig = {
  gatewayName: "bridge_default_gateway",
  routes: {
    adminCreateBridgePolicy: {
      gateway: "bridge_default_gateway",
      action: "adminCreateBridgePolicy",
    },
    adminEnsureBridgePatient: {
      gateway: "bridge_default_gateway",
      action: "adminEnsureBridgePatient",
    },
    adminListBookableProviderEligibility: {
      gateway: "bridge_default_gateway",
      action: "adminListBookableProviderEligibility",
    },
    adminResolveBridgePolicyStatus: {
      gateway: "bridge_default_gateway",
      action: "adminResolveBridgePolicyStatus",
    },
    adminRevalidateBridgePolicy: {
      gateway: "bridge_default_gateway",
      action: "adminRevalidateBridgePolicy",
    },
    createBridgePolicy: {
      gateway: "bridge_default_gateway",
      action: "createBridgePolicy",
    },
    createBridgeServiceEligibility: {
      gateway: "bridge_default_gateway",
      action: "createBridgeServiceEligibility",
    },
    ensureBridgePatient: {
      gateway: "bridge_default_gateway",
      action: "ensureBridgePatient",
    },
    listBookableProviderEligibility: {
      gateway: "bridge_default_gateway",
      action: "listBookableProviderEligibility",
    },
    previewBridgeMappedNote: {
      gateway: "bridge_default_gateway",
      action: "previewBridgeMappedNote",
    },
    resolveBridgePolicyStatus: {
      gateway: "bridge_default_gateway",
      action: "resolveBridgePolicyStatus",
    },
    resolveBridgeServiceEligibilityStatus: {
      gateway: "bridge_default_gateway",
      action: "resolveBridgeServiceEligibilityStatus",
    },
    revalidateBridgePolicy: {
      gateway: "bridge_default_gateway",
      action: "revalidateBridgePolicy",
    },
    triggerDiscoverProviders: {
      gateway: "bridge_default_gateway",
      action: "triggerDiscoverProviders",
    },
    triggerProviderResolve: {
      gateway: "bridge_default_gateway",
      action: "triggerProviderResolve",
    },
  },
} as const satisfies CallableApiConfig<BridgeRouteTypeMap>;
